module.exports = __webpack_public_path__ + "img/root11.0bd48f5c.png";